import styled from "styled-components";

export const PremiumPubWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 500px;
  height: 100svh;
  overscroll-behavior: none;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 100px;

  .title {
    font-weight: 700;
    font-size: 20px;
  }
`;
